<template>
	<div>
		<div class="box">
			<div class="line1">
				<div style="padding-left: 10px;">小明</div>
				<div style="padding-right: 10px;">101-3</div>
			</div>
			<div class="line2">
				<!--离床、掉线-->
				<div style="width: 100%;">
					<div style="width: 100%;">
						<img style="margin: 0 auto;" src="http://org.yymedic.com/images/cardBreath.svg?4d21686641eae8e4dc81f52f09c226c8"/>
					</div>
					<!--<div>离线</div>-->
				</div>
				<!--在床-->
				<div></div>
			</div>
			<div class="line3">
				<span>1</span>
				<span>2</span>
				<span>3</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				websock: null
			}
		},
		beforeRouteLeave(to,from,next){
			console.log('离开页面了离开页面了离开页面了离开页面了')
        	this.websock.close()
        	next()
        },
		methods:{
			initWebSocket(){ //初始化weosocket
//      		const wsuri = "ws://msg.yymedic.com/socket.io/"
        		const wsuri = "ws://msg.yymedic.com/socket.io/?guardianId=5c749c4b47ca8e00017cf4ef&ticket=dcdc79ee-4aa0-4934-ba35-e795c273630f&ver=1&EIO=3&transport=websocket&sid=lpitQahlpWolUEYVAAIg"
        		this.websock = new WebSocket(wsuri)
        		this.websock.onmessage = this.websocketonmessage
        		this.websock.onopen = this.websocketonopen
        		this.websock.onerror = this.websocketonerror
        		this.websock.onclose = this.websocketclose;
     		},
     		websocketonopen(){ //连接建立之后执行send方法发送数据
     			console.log("WebSocket连接成功");
//      		let actions = {"test":"12345"}
//      		this.websocketsend(JSON.stringify(actions));
      		},
			websocketonerror(){//连接建立失败重连
	        	this.initWebSocket();
	        	console.log("WebSocket连接发生错误");
	      	},
	      	websocketonmessage(e){ //数据接收
	        	const redata = JSON.parse(e.data);
	        	console.log("请求结果",redata.value); 
	      	},
	      	websocketsend(Data){//数据发送
	        	this.websock.send(Data);
	      	},
	      	websocketclose(e){  //关闭
	        	console.log('断开连接',e);
	      	}

		},
		created(){
			this.initWebSocket()

		},
		destroyed(){
			this.websock.close() //离开路由之后断开websocket连接
		}
	}
</script>

<style scoped>
	.box {
		width: 250px;
		border: 1px solid #999;
		box-shadow: 0px 2px 10px #999;
	}
	.line1 {
		display: flex;
		justify-content: space-between;
	}
	.line2 {
		display: flex;
		justify-content: space-around;
	}
	.line3 {
		display: flex;
		justify-content: flex-end;
	}
	
</style>


// WEBPACK FOOTER //
// SmartCare.vue?2f10e603